// extracted by mini-css-extract-plugin
module.exports = {"error500":"error500_error500__8XOnl","stories-wrap":"error500_stories-wrap__e_cqK"};